/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { useMutateUserProfile } from '../../hooks/api/useUserProfile';
import uploadToS3Bucket from '../../utils/uploadToS3Bucket';
import Modal from '../../components/modal/Modal';
import useModal from '../../hooks/useModal';
import AlertCustom from '../../components/alert/AlertCustom';
import Button from '../../components/button/Button';
import FormEditIntro from './FormEditIntro';

const useEditIntro = () => {
    const [isEditIntro, closeEditIntro, openEditIntro] = useModal(false);
    const [alertSuccess, closeAlertSuccess, openAlertSuccess] = useModal();

    const {
        mutate,
        // error,
        isLoading: isPostLoading
        // isSuccess
    } = useMutateUserProfile();

    const [resumeFile, setResumeFile] = useState(null);
    const [uploadingResume, setUploadingResume] = useState(false);

    const submitData = values => {
        values.boardDirectors =
            values.boardDirectors === '1' || values.boardDirectors === true;
        values.vendorOffers =
            values.vendorOffers === '1' || values.vendorOffers === true;
        values.privateEmail =
            values.privateEmail === '1' || values.privateEmail === true;
        values.privatePhone =
            values.privatePhone === '1' || values.privatePhone === true;
        console.log('SUBMITTING DATA AFTER', values);
        mutate(values, {
            onError: err => {
                console.log('MUTATE FAILED', err);
            },
            onSuccess: () => {
                setTimeout(() => {
                    closeEditIntro();
                    openAlertSuccess();
                }, 300);
            }
        });
    };

    const handleSubmit = values => {
        // We set resume to null because we have a file uploaded in input#resume
        // but we want to save only its location on S3
        values.resume = null;
        // if user added a rseume, we upload it before mutating user data
        if (resumeFile) {
            setUploadingResume(true);
            uploadToS3Bucket(resumeFile)
                .then(data => {
                    values.resume = data.location;
                })
                .catch(err => console.error('error uploading', err))
                .finally(() => {
                    setUploadingResume(false);
                    submitData(values);
                });
        } else {
            submitData(values);
        }
    };

    const isUploadingAndSaving = isPostLoading || uploadingResume;
    const modalProps = {
        isEditIntro,
        closeEditIntro,
        isUploadingAndSaving,
        handleSubmit,
        setResumeFile,
        alertSuccess,
        closeAlertSuccess
    };

    const EditIntroJSX = <ModalEditIntro {...modalProps} />;

    return [openEditIntro, EditIntroJSX];
};

export default useEditIntro;

const ModalEditIntro = ({
    isEditIntro,
    closeEditIntro,
    isUploadingAndSaving,
    handleSubmit,
    setResumeFile,
    alertSuccess,
    closeAlertSuccess
}) => (
    <>
        <Modal
            showModal={isEditIntro}
            closeModal={closeEditIntro}
            btnCloseModal={true}
            position="p-top"
            width="modal-md">
            <FormEditIntro
                isUploadingAndSaving={isUploadingAndSaving}
                handleSubmit={handleSubmit}
                setResumeFile={setResumeFile}
            />
        </Modal>

        <AlertCustom
            showModal={alertSuccess}
            title="Saved successfully"
            subtitle="Information has been saved successfully"
            typeAlert="success">
            <>
                <Button
                    classs="btnMain"
                    text="Ok"
                    onClick={() => {
                        closeAlertSuccess();
                    }}
                />
            </>
        </AlertCustom>
    </>
);
